import * as React from "react";
import { LoadingSkeletonType } from "./Contents";

export interface ILoadingSkeletonProps {
    type: LoadingSkeletonType;
}
export const LoadingSkeleton = (props: ILoadingSkeletonProps) => {
    switch (props.type) {
        case LoadingSkeletonType.Chart:
            return chart;
            case LoadingSkeletonType.PieChartAndTable:
                return chartAndTable;
        case LoadingSkeletonType.Simple: 
            return simple;
        case LoadingSkeletonType.Table:
            return table;
    }
};

const chart = (
    // @TODO change to a better skeleton for rectangular charts
    // - See SLP-80813
    <div aria-hidden={true}>
        <div className="skeleton mb-4"></div>
        <div className="skeleton mb-4"></div>
        <div className="skeleton mb-4"></div>
        <div className="skeleton mb-4"></div>
        <div className="skeleton mb-4"></div>
    </div>
);

const chartAndTable = (
    <div className="row" aria-hidden={true}>
        <div className="col-12 col-md-auto">
            <div className="skeleton pie-chart mt-60"></div>
        </div>
        <div className="col-12 col-md-fluid pb-24">
            <div className="row">
                <div className="col-6 col-auto">
                    <div className="skeleton"></div>
                </div>
                <div className="col-6 col-auto">
                    <div className="skeleton"></div>
                </div>
            </div>
            <div aria-hidden="true">
                <div className="row mini-gutter">
                    <div className="col-fluid">
                        <div className="skeleton mb-4"></div>
                    </div>
                    <div className="col-fluid">
                        <div className="skeleton mb-4"></div>
                    </div>
                    <div className="col-fluid">
                        <div className="skeleton mb-4"></div>
                    </div>
                    <div className="col-fluid">
                        <div className="skeleton mb-4"></div>
                    </div>
                    <div className="col-fluid">
                        <div className="skeleton mb-4"></div>
                    </div>
                </div>
                <div className="skeleton mb-4"></div>
                <div className="skeleton mb-4"></div>
                <div className="skeleton mb-4"></div>
                <div className="skeleton mb-4"></div>
                <div className="skeleton mb-4"></div>
            </div>
        </div>
    </div>
);

const simple = (
    <div aria-hidden={true}>
        <div className="skeleton"></div>
    </div>
);

const table = (
    <div aria-hidden={true}>
        <div className="row mini-gutter" >
            <div className="col-fluid" >
                <div className="skeleton mb-4" />
            </div>
            <div className="col-fluid" >
                <div className="skeleton mb-4" />
            </div>
            <div className="col-fluid" >
                <div className="skeleton mb-4" />
            </div>
            <div className="col-fluid" >
                <div className="skeleton mb-4" />
            </div>
            <div className="col-fluid" >
                <div className="skeleton mb-4" />
            </div>
        </div>

        <div className="skeleton mb-4" />
        <div className="skeleton mb-4" />
        <div className="skeleton mb-4" />
        <div className="skeleton mb-4" />
        <div className="skeleton mb-4" />
        <div className="skeleton mb-4" />
        <div className="skeleton mb-4" />

    </div>        
);

